import React from 'react';
import {  Typography } from '@mui/material';
import DataGridTable from '../Components/TableData';
import { Box } from '@mui/joy';




const TestPage = () => {

  const data = [
    {
      id: 1,
      numero: 'EXP12345',
      nbr_colis: 5,
      nbr_palettes: 2,
      poids: '150kg',
      longueur: '3m',
      largeur: '1.5m',
      hauteur: '1.2m',
      valeur: '2000€',
      port: 'Marseille',
      espece: 'Cash',
      cheque: 'No',
      traite: 'No',
      nbr_BL: 3,
      types_livraisons_id: 'Standard',
      types_services_id: 'Express',
      status_id: 'In Transit',
      date_status: '2024-12-25',
      sources_id: 'Website',
      poi_ramassage_id: 'Paris Depot',
      poi_livraison_id: 'Marseille Warehouse',
      clients_id: 'Client A',
      users_id: 'User 1',
    },
    {
      id: 2,
      numero: 'EXP12346',
      nbr_colis: 3,
      nbr_palettes: 1,
      poids: '100kg',
      longueur: '2.5m',
      largeur: '1.2m',
      hauteur: '1.0m',
      valeur: '1200€',
      port: 'Toulon',
      espece: 'Transfer',
      cheque: 'Yes',
      traite: 'Yes',
      nbr_BL: 2,
      types_livraisons_id: 'Priority',
      types_services_id: 'Standard',
      status_id: 'Delivered',
      date_status: '2024-12-20',
      sources_id: 'Mobile App',
      poi_ramassage_id: 'Nice Depot',
      poi_livraison_id: 'Toulon Branch',
      clients_id: 'Client B',
      users_id: 'User 2',
    },
    {
      id: 3,
      numero: 'EXP12347',
      nbr_colis: 10,
      nbr_palettes: 4,
      poids: '500kg',
      longueur: '6m',
      largeur: '2m',
      hauteur: '2.5m',
      valeur: '5000€',
      port: 'Lyon',
      espece: 'Bank Transfer',
      cheque: 'Yes',
      traite: 'No',
      nbr_BL: 5,
      types_livraisons_id: 'Same Day',
      types_services_id: 'Premium',
      status_id: 'Pending',
      date_status: '2024-12-22',
      sources_id: 'Phone Call',
      poi_ramassage_id: 'Lyon Depot',
      poi_livraison_id: 'Lyon Office',
      clients_id: 'Client C',
      users_id: 'User 3',
    },
    {
      id: 4,
      numero: 'EXP12348',
      nbr_colis: 8,
      nbr_palettes: 3,
      poids: '250kg',
      longueur: '4m',
      largeur: '1.8m',
      hauteur: '1.8m',
      valeur: '2500€',
      port: 'Bordeaux',
      espece: 'Cash',
      cheque: 'No',
      traite: 'Yes',
      nbr_BL: 4,
      types_livraisons_id: 'Standard',
      types_services_id: 'Express',
      status_id: 'Shipped',
      date_status: '2024-12-23',
      sources_id: 'Email',
      poi_ramassage_id: 'Bordeaux Depot',
      poi_livraison_id: 'Bordeaux Warehouse',
      clients_id: 'Client D',
      users_id: 'User 4',
    },
  ];
  

  const columns = [
    {
      accessorKey: 'id', // Accessor key for the 'id' field
      header: 'ID',
      size: 200,
    },
    {
      accessorKey: 'numero', // Accessor key for 'numero'
      header: 'Numéro d\'expédition',
      size: 200,
    },
    {
      accessorKey: 'nbr_colis', // Accessor key for 'nbr_colis'
      header: 'Nombre de colis',
      size: 200,
    },
    {
      accessorKey: 'nbr_palettes', // Accessor key for 'nbr_palettes'
      header: 'Nombre de palettes',
      size: 200,
    },
    {
      accessorKey: 'poids', // Accessor key for 'poids'
      header: 'Poids',
      size: 200,
    },
    {
      accessorKey: 'longueur', // Accessor key for 'longueur'
      header: 'Longueur',
      size: 200,
    },
    {
      accessorKey: 'largeur', // Accessor key for 'largeur'
      header: 'Largeur',
      size: 200,
    },
    {
      accessorKey: 'hauteur', // Accessor key for 'hauteur'
      header: 'Hauteur',
      size: 200,
    },
    {
      accessorKey: 'valeur', // Accessor key for 'valeur'
      header: 'Valeur',
      size: 200,
    },
    {
      accessorKey: 'port', // Accessor key for 'port'
      header: 'Port',
      size: 200,
    },
    {
      accessorKey: 'espece', // Accessor key for 'espece'
      header: 'Espèces',
      size: 200,
    },
    {
      accessorKey: 'cheque', // Accessor key for 'cheque'
      header: 'Chèque',
      size: 200,
    },
    {
      accessorKey: 'traite', // Accessor key for 'traite'
      header: 'Traite',
      size: 200,
    },
    {
      accessorKey: 'nbr_BL', // Accessor key for 'nbr_BL'
      header: 'Nombre BL',
      size: 200,
    },
    {
      accessorKey: 'types_livraisons_id', // Accessor key for 'types_livraisons_id'
      header: 'Type de livraison',
      size: 200,
    },
    {
      accessorKey: 'types_services_id', // Accessor key for 'types_services_id'
      header: 'Type de service',
      size: 200,
    },
    {
      accessorKey: 'status_id', // Accessor key for 'status_id'
      header: 'Status',
      size: 200,
    },
    {
      accessorKey: 'date_status', // Accessor key for 'date_status'
      header: 'Date du status',
      size: 200,
    },
    {
      accessorKey: 'sources_id', // Accessor key for 'sources_id'
      header: 'Source',
      size: 200,
    },
    {
      accessorKey: 'poi_ramassage_id', // Accessor key for 'poi_ramassage_id'
      header: 'Point de ramassage',
      size: 200,
    },
    {
      accessorKey: 'poi_livraison_id', // Accessor key for 'poi_livraison_id'
      header: 'Point de livraison',
      size: 200,
    },
    {
      accessorKey: 'clients_id', // Accessor key for 'clients_id'
      header: 'Client',
      size: 200,
    },
    {
      accessorKey: 'users_id', // Accessor key for 'users_id'
      header: 'Utilisateur',
      size: 200,
    },
  ];

  return (
    <Box sx={{ width: '80%', display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
      <Typography>This is a test page</Typography>
      <DataGridTable data={data}  columns={columns} />
    </Box>
     
  
  );
};

export default TestPage;


